import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import styles, { mainCls } from './styles';
import createStyle from '../../Utils/createStyle';
import makeClassName from '../../Utils/makeClassName';
import { isString } from '../../Utils/checkVarType';
import arraysEqual from '../../Utils/arraysEqual';

const useStyles = createStyle(styles);

const propTypes = {
  /**
   * Device type (for styling purpouses)
   */
  device: PropTypes.oneOf(
    [
      '',
      'smartphone',
      'tablet',
      'desktop',
    ],
  ),
  /**
   * Name of property to update
   */  
  filter: PropTypes.string,
  /**
   * Default value
   */  
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Array),
  ]),   
  /**
   * Initial value
   */
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Array),
  ]), 
  /**
   * Set of values (API format)
   */  
  values: PropTypes.instanceOf(Array),
  /**
   * Set of values (UX format)
   */    
  displayValues: PropTypes.instanceOf(Array),
  /**
   * Pass new value to parent component
   */
  updateValue: PropTypes.func,

  className: PropTypes.string,

  /**
   * Class for radio button
   */
  clsBtn: PropTypes.string,
};
const defaultProps = {
  device: '',
  filter: '',
  defaultValue: '' | [],
  value: '' | [],
  values: [],
  displayValues: [], 
  updateValue: () => {},
  className: null,
  clsBtn: null,
};
const RadioInput = ({
  device,
  filter,
  defaultValue,  
  value,
  values,
  displayValues,
  updateValue,
  className,
  clsBtn,
}) => {
  const classes = useStyles();
  const [state, setState] = useState(value);
  useEffect(
    () => {
      if (
        (isString(value) && value === defaultValue)
        || arraysEqual(value, defaultValue)
       ) {
        setState(defaultValue);
      }
    }, [value, defaultValue],
  );
  const changeValue = (newValue) => {
    let newState;
    if (isString(value)) {
      if (newValue === state) {
        newState = defaultValue;
      } else {
        newState = newValue;
      }
    } else {
      newState = state.slice(0);
      if (newState.indexOf(newValue) > -1) {
        newState.splice(0, 1);
        newState.push(defaultValue[0]);
      } else {
        newState.splice(0, 1);
        newState.push(newValue);
      }
    }
    updateValue({ [filter]: newState });
    setState(newState);
  };
  const btnCls = (ind) => makeClassName([
    classes[mainCls],
    className,
    ind === displayValues.length - 1 ? 'lastRadio' : null,
    device === 'desktop' ? device : null
  ]);
  const clsBtnCustom = clsBtn ? classes[`${mainCls}${clsBtn}`] : '';
  const radioCls = (ind) => makeClassName([
    classes[`${mainCls}__radio`],
    clsBtnCustom,
    state.indexOf(values[ind]) > -1 ? 'checked' : '',
  ]);
  return (
    <>
      {
        displayValues.map(
          (val, index) => (
            <button
              key={`radioinput_${filter}_${val}`}
              type="button"
              className={btnCls(index)}
              onClick={() => { changeValue(values[index]); }}
            >
              <span className={radioCls(index)} />
              {val}
            </button>
          ),
        )
      }
    </>
  );
};
RadioInput.propTypes = propTypes;
RadioInput.defaultProps = defaultProps;
export default RadioInput;
